import { format, parseISO } from 'date-fns'
import { ja } from 'date-fns/locale'

/**
 * 日付関連のユーティリティ関数
 */

/**
 * 日付をYYYY-MM-DD形式にフォーマット
 */
export const formatDate = (date: Date): string => {
  return format(date, 'yyyy-MM-dd')
}

/**
 * 日付をYYYY年MM月DD日形式にフォーマット（日本語）
 */
export const formatDateJa = (date: Date): string => {
  return format(date, 'yyyy年MM月dd日', { locale: ja })
}

/**
 * 日付を表示用フォーマットに変換
 */
export const formatDateTime = (date: Date): string => {
  return format(date, 'yyyy-MM-dd HH:mm:ss')
}

/**
 * ISO文字列をDateオブジェクトに変換
 */
export const parseDate = (dateString: string): Date => {
  return parseISO(dateString)
}

/**
 * 現在の日付を取得
 */
export const getCurrentDate = (): Date => {
  return new Date()
}

/**
 * 年齢から生年月日を概算（年初め基準）
 */
export const estimateBirthYearFromAge = (age: number): number => {
  const currentYear = new Date().getFullYear()
  return currentYear - age
}

/**
 * 生年月日から年齢を計算
 */
export const calculateAge = (birthday: string): number => {
  const birthDate = new Date(birthday)
  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()

  // 誕生日がまだ来ていない場合は1歳引く
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }

  return age
}

/**
 * 生年月日から生年を取得
 */
export const getBirthYear = (birthday: string): number => {
  return new Date(birthday).getFullYear()
}
